module.exports = __webpack_public_path__ + "static/media/whiskey.feb7cbae.svg";